(function(){

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=.thetasteshop.com";
  }
  
  (async () => {
    const rawResponse = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      }
    });
    const content = await rawResponse.json();
    console.log(content);
    setCookie('cpclid', content.attributes.eftid, 365);
  })();
  
})();